"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const buildCallablePrintRemotePDF = (args) => async ({ functionId, callbacks, executeProcesses, entryVars: { uri, }, }) => {
    if (!(0, valueIsString_1.default)(uri)) {
        executeProcesses(functionId, callbacks.error, 'uri is not a string');
        return;
    }
    await args.openPdfToPrint(uri).then(() => {
        executeProcesses(undefined, callbacks.success);
    }).catch((error) => {
        executeProcesses(functionId, callbacks.onError, `${error}`);
    });
};
exports.default = buildCallablePrintRemotePDF;
